export default "/assets/website/images/2014.jpeg?08436ea234d337723a6c48a6ecc1a819";